import React from 'react'
import { observable, action, runInAction } from 'mobx'
import API from '@api/hotel/order'
import { Modal, message } from 'hljd'
class Store {
  @observable id = ''
  @observable visible = false
  @observable hotelName = ''
  @observable hallData = []
  @observable imgList = []

  @action
  getHall = async params => {
    let { data } = await API.GetHall(params)
    runInAction('gethall', () => {
      this.hallData = data
    })
  }

  @action
  OrderInfo = async params => {
    let {
      data: { merchant }
    } = await API.OrderInfo(params)
    runInAction('info', () => {
      this.hotelName = merchant.name
    })
  }

  @observable
  form = {
    contract_money: '',
    eat_time: '',
    hotel_hall_id: '',
    id: this.id,
    price: '',
    proof_photos: this.imgList,
    remark: '',
    tables_num: '',
    wedding_day: '',
    backup_table_num: '',
    other_fee: '',
    deposit_money: ''
  }

  @action
  reasonInfo = res => () => {
    let _res = res
    if (!res) {
      _res = '没有抒写原因'
    }
    Modal.info({
      title: '不通过原因',
      content: (
        <div>
          <p>{_res}</p>
        </div>
      ),
      onOk() {}
    })
  }

  @action
  showModal = $id => () => {
    this.id = $id
    this.getHall()
    this.OrderInfo('id=' + $id)
    this.visible = true
    this.imgs = []
    this.hallData = []
  }
  @action
  handleCancel = () => {
    this.visible = false
  }

  @action
  setTable_backUp = e => {
    this.form.backup_table_num = e.target.value
  }

  @action
  setHPrice_other = e => {
    this.form.other_fee = e.target.value
  }

  @action
  setHdeposit = e => {
    this.form.deposit_money = e.target.value
  }

  @action
  setDate = (date, dateString) => {
    this.form.wedding_day = dateString
  }

  @action
  setHall = e => {
    this.form.hotel_hall_id = e
  }

  @action
  setCol = e => {
    this.form.eat_time = e.join(',')
  }

  @action
  setTable = e => {
    this.form.tables_num = e.target.value
  }

  @action
  setTablePrice = e => {
    this.form.price = e.target.value
  }

  @action
  setHPrice = e => {
    this.form.contract_money = e.target.value
  }
  @observable imgs = []

  @action
  upImg = (e, i) => {
    this.imgs = this.imgs.concat([e])
    let obj = {
      img: e,
      width: i.width,
      height: i.height
    }
    this.imgList.push(obj)
  }

  @action
  removeImg = index => {
    this.imgs = this.imgs.filter((item, i) => i !== index)
    this.imgList.splice(index, 1)
  }

  @action
  sendForm = () => {
    this.form.id = this.id

    if (this.form.contract_money == '') {
      message.warning('请填写婚宴总价')
    } else if (this.form.wedding_day == '') {
      message.warning('请填写婚期')
    } else if (this.form.eat_time == '') {
      message.warning('请填写市别')
    } else if (this.form.hotel_hall_id == '') {
      message.warning('请填写酒店场地')
    } else if (this.form.price == '') {
      message.warning('请填写餐标')
    } else if (this.form.tables_num == '') {
      message.warning('请填写桌数')
    } else if (this.form.backup_table_num == '') {
      message.warning('请填写备用桌数')
    } else if (this.form.other_fee == '') {
      message.warning('请填写其他费用')
    } else if (this.form.deposit_money == '') {
      message.warning('请填写定金')
    } else {
      this.PostOrderFB(this.form)
    }
  }

  @action
  PostOrderFB = async params => {
    let { success, msg } = await API.PostOrderFB(params)
    runInAction('PFB', () => {
      if (success) {
        this.visible = false
        this.form.proof_photos = this.imgList
        this.GetOrderFB('id=' + this.id)
        message.success(msg)
      }
    })
  }
}
export default new Store()
